<template>
    <div class="addPromotion">
        <el-form :model="promotion" ref="form" :inline="false" size="normal" :label-position="'top'">
            <el-form-item label="促销名称">
                <el-input v-model="promotion.name" placeholder="" size="normal" clearable></el-input>
            </el-form-item>
            <el-form-item label="满足金额">
                <el-input v-model="promotion.totalAmount" placeholder="" size="normal" clearable type="number"></el-input>
            </el-form-item>
            <el-form-item label="赠送金额">
                <el-input v-model="promotion.giftAmount" placeholder="" size="normal" clearable type="number"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="dataStatusLabel" placeholder="状态" @focus="Select('state')" style="width: 100%;">
                </el-select>
            </el-form-item>
            <el-form-item label="是否显示">
                <el-select v-model="showStatusLabel" placeholder="是否显示" @focus="Select('look')" style="width: 100%;">
                </el-select>
            </el-form-item>
            <el-form-item class="formButton">
                <el-button @click="onCancel">取消</el-button>
                <el-button type="primary" @click="onSubmit">确定</el-button>
            </el-form-item>
        </el-form>
        <nut-picker :is-visible="isVisible" :list-data="activeListData" @close="closeSwitch()"
            @confirm="confirm"></nut-picker>
    </div>
</template>
<script>
import { addPromotion, upDatePromotion } from '@/api/newApi'
import { Toast } from "vant";
import "vant/lib/toast/style/index";
export default {
    data() {
        return {
            promotion: {
                name:"",
                totalAmount:"",
                giftAmount:"",
                dataStatus:"",
                showStatus:""
            },
            isVisible: false,
            activeListData: [],
            showStatusLabel: "",
            dataStatusLabel: "",
            listData: [
                [
                    {
                        label: "0",
                        type: "state",
                        value: "正常"
                    },
                    {
                        label: "1",
                        type: "state",
                        value: "禁用"
                    }
                ]
            ],
            listData2: [
                [
                    {
                        label: "1",
                        type: "look",
                        value: "不显示"
                    },
                    {
                        label: "0",
                        type: "look",
                        value: "显示"
                    }
                ]
            ],
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.promotion = this.$route.query
        }
    },
    methods: {
        onSubmit() {
            for (const key in this.promotion) {
                if (this.promotion[key] == "") {
                    Toast("请将信息填写完整后提交");
                    return
                }
            }
            if (this.$route.query.id) {
                upDatePromotion(this.promotion).then(res => {
                    if (res.message.status == 200) {
                        Toast("修改成功");
                        this.$router.push(
                            {
                                path: "/admin/promotion"
                            }
                        )
                    }
                })
            } else {
                addPromotion(this.promotion).then(res => {
                    if (res.message.status == 200) {
                        Toast("添加成功");
                        this.$router.push(
                            {
                                path: "/admin/promotion"
                            }
                        )
                    }
                })
            }
        },
        closeSwitch() {
            this.isVisible = false
        },
        Select(type) {
            this.isVisible = true
            if (type == "state") {
                this.activeListData = this.listData
            } else {
                this.activeListData = this.listData2
            }
        },
        confirm(event) {
            if (event[0].type == "state") {
                this.promotion.dataStatus = event[0].label
                this.dataStatusLabel = event[0].value
            } else {
                this.promotion.showStatus = event[0].label
                this.showStatusLabel = event[0].value
            }
            this.isVisible = false
        },
        onCancel() {
            this.$router.push(
                {
                    path: "/admin/promotion"
                }
            )
        }
    },
}
</script>
<style lang="scss" scoped>
@import"@/assets/sass/state.scss";

.addPromotion {
    padding: .4167rem;

    ::v-deep .el-form-item__content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    ::v-deep .el-button {
        width: 45%;
    }
}

::v-deep .el-input__inner {
    background-color: #0D1A3C;
    border-color: transparent;
    color: #A2BDE1;
}

::v-deep .nut-picker {
    background-color: transparent;
}

::v-deep .nut-picker-cancel-btn {
    color: #A2BDE1;
}

::v-deep .nut-picker-confirm-btn {
    color: #A2BDE1;
}

::v-deep .nut-picker-list .nut-picker-content,
::v-deep .nut-picker-list .nut-picker-item {
    background-color: #0D1A3C !important;
    color: #fff;
}
</style>